module.exports = __webpack_public_path__ + "img/companyinf_qqbg_img.916cc8c5.webp";